import '@nirmata/web-components/styles.css';
import './index.css';

import { Toaster } from '@nirmata/web-components/ui/sonner';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);
